<template>
  <section class="office">
    <div class="section-wrap">
      <Header :trigger="trigger"/>
    </div>
    <div class="container">
      <h1 class="promo__head">do you want to work with os or rent a desk? sit with us, we can help you.</h1>
      <p class="promo__text">we have space in out office and want talented people to sit together. only requirement is that you are in the same business</p>
      <p class="promo__sub-text">pricing is 2.800 DKK a month – min. 3 month of rent</p>
      <router-link class="promo__cta" :to="{ name: 'Contact', params: {} }">hear more about it <span class="link promo__cta__btn"></span></router-link>
    </div>
  </section>
</template>

<script>
import './style.scss';
import Header from '@/components/Header/Header';

export default {
  name: 'Office',
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Office/Office.vue